import React, { FC, useEffect, useState } from "react";
import { Avatar, Box, Button, Divider, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import BadgeImage from "./ui-elements/badge-image";
import ImageGrid from "./image-grid";

import useResponsive from "../hooks/useResponsive";
import { apiBookmarkPost, apiLikePost, apiRepostPost } from "../api/post";
import { useNotificationService } from "../hooks/notification";
import { PATH_DASHBOARD } from "../routes/path";
import { formatDateAndTimeFromString } from "../utils/date-setup";
import LineProgress from "./ui-elements/line-progress";
import { textSty } from "./ui-elements/styles-input";

import TruncatedLimitContent from "./ui-elements/typography-limit-content";

interface ReportContainerPropsType {
  image: any;
  link: number;
  content: string;
  account: string;
  title: string;
  source: string;
  badge: number;
  id: number;
  avatarImg: any;
  date: string;
  data: any;
  current_user_liked: boolean;
  current_user_reposted: boolean;
  current_user_bookmarked: boolean;
  social: {
    message: number;
    repost: number;
    like: number;
  };
}

const ReportContainer: FC<ReportContainerPropsType> = ({
  image,
  title,
  link,
  id,
  account,
  badge,
  content,
  social,
  source,
  current_user_liked,
  current_user_reposted,
  current_user_bookmarked,
  date,
  avatarImg,
  data,
}) => {
  const navigate = useNavigate();
  const { showNotification } = useNotificationService();
  const isMedium = useResponsive("down", "md", "xl");
  const [social_links, setSocial_links] = useState({
    likes: social?.like,
    reposts: social?.repost,
    messages: social?.message,
  });
  const [liked, setLiked] = useState(current_user_liked);
  const [reposted, setReposted] = useState(current_user_reposted);

  // Construct full URL
  const baseUrl = window.location.origin;
  const additionalPath = `/posts?post_id=${id}`;
  const fullShareLink = `${baseUrl}${additionalPath}`;
  // Copy function using Clipboard API
  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(fullShareLink);
      showNotification("Link copied!", "success");
    } catch (err) {
      console.error("Failed to copy: ", err);
      showNotification("Failed to copy the link. Try again.", "error");
    }
  };

  const like_post = async (post_id: number) => {
    try {
      const response = await apiLikePost(post_id);
      if (response.status === 200) {
        if (response.data.message === "added") {
        } else {
        }
        //
      } else {
      }
    } catch (error) {
      //
    }
  };

  // cookies like settings
  const handleLike = () => {
    setLiked(!liked);
  };

  const handle_like = (id: number) => {
    if (liked) {
      // remove one from current list
      setSocial_links((prev) => ({ ...prev, likes: prev?.likes - 1 }));

      handleLike();
      // send request
      like_post(id);
    } else {
      //  add one to current list
      setSocial_links((prev) => ({ ...prev, likes: prev?.likes + 1 }));
      handleLike();
      // send request
      like_post(id);
    }
  };

  return (
    <Box
      sx={{
        border: "1px solid rgba(231, 235, 239, 1)",
        my: 2,
        borderRadius: "8px",
        padding: isMedium ? 1 : 2,
        minHeight: 250,
        width: "94%",
        marginHorizontal: "auto",
      }}
    >
      <Box
        sx={{
          marginVertical: 2,
        }}
      >
        <Stack
          direction="row"
          alignItems={"center"}
          justifyContent={"space-between"}
          onClick={() =>
            navigate(PATH_DASHBOARD.post, {
              state: { postId: id },
            })
          }
        >
          <Stack
            direction={"row"}
            alignItems={"center"}
            spacing={2}
            sx={{
              marginBottom: 2,
            }}
          >
            {/* image */}

            <Avatar
              src={avatarImg}
              alt="avat"
              sx={{ width: 32, height: 32 }}
              // Fallback will automatically show if src fails to load
              // You can also provide a fallback image
              slotProps={{
                img: {
                  onError: (e: any) => {
                    e.currentTarget.src = "/assets/images/home/irep-image.png";
                  },
                },
              }}
            />

            <Stack>
              <Stack direction={"row"} spacing={1}>
                <Typography sx={{ fontSize: 13 }} color="black">
                  {account}
                </Typography>
                {badge > 0 && <BadgeImage badge={badge} />}
              </Stack>
              <Stack>
                <Typography sx={{ fontSize: 12 }} color="">
                  {formatDateAndTimeFromString(date)}
                </Typography>
              </Stack>

              <Typography sx={{ fontSize: 12 }} color="primary">
                {source}
              </Typography>
            </Stack>
            {/*dot image */}
          </Stack>
          {/* <DotsVerticalIcon /> */}
        </Stack>
        <Box sx={{ ml: isMedium ? 0 : 3 }}>
          <Stack sx={{ cursor: "pointer" }}>
            <Typography
              color="black"
              sx={{
                fontSize: 16,
                marginBottom: 2,
              }}
              onClick={() =>
                navigate(PATH_DASHBOARD.post, {
                  state: { postId: id },
                })
              }
            >
              {title}
            </Typography>
            <Box onClick={() => navigate(link)}>
              <ImageGrid
                images={image} // Pass images as an array
              />
            </Box>
            {source === "petition" && (
              <Box
                onClick={() =>
                  navigate(PATH_DASHBOARD.post, {
                    state: { postId: id },
                  })
                }
              >
                <LineProgress
                  total={data?.target_signatures}
                  current={data?.signatures}
                />
                <Stack direction={"row"} justifyContent={"space-between"}>
                  <Stack>
                    <Typography sx={textSty}>{data?.signatures}</Typography>
                    <Typography sx={textSty}>Signature</Typography>
                  </Stack>
                  <Stack>
                    <Typography sx={textSty}>Goal</Typography>
                    <Stack direction={"row"} spacing={1}>
                      <Typography sx={textSty}>
                        {data?.target_signatures}
                      </Typography>
                      <Typography sx={textSty}>Signature</Typography>
                    </Stack>
                  </Stack>
                </Stack>
              </Box>
            )}
            <Stack sx={{ mt: 2 }}>
              {/* <Typography
              sx={{
                fontSize: 13,
              }}
            >
              {content}
            </Typography> */}
              <TruncatedLimitContent content={content} />
            </Stack>
          </Stack>
          {social_links.likes >= 0 && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                my: 2,
              }}
            >
              <Stack
                direction={"row"}
                alignItems={"center"}
                spacing={1}
                sx={{ cursor: "pointer" }}
                onClick={() =>
                  navigate(PATH_DASHBOARD.post, {
                    state: { postId: id },
                  })
                }
              >
                {social?.message >= 1 ? (
                  <img
                    src={"assets/icons/social/message-text.svg"}
                    style={{ width: 18, height: 18 }}
                  />
                ) : (
                  <img
                    src={"assets/icons/social/message-text.png"}
                    style={{ width: 18, height: 18 }}
                  />
                )}

                <Typography
                  variant="caption"
                  sx={{
                    color:
                      social?.message >= 1 ? "#459173" : "rgba(74, 94, 109, 1)",
                    fontWeight: 500,
                  }}
                >
                  {social.message} {isMedium ? "" : "comments"}
                </Typography>
              </Stack>

              <Stack
                direction={"row"}
                alignItems={"center"}
                sx={{ cursor: "pointer" }}
                spacing={1}
                onClick={() => handle_like(id)}
              >
                {liked && social_links?.likes > 0 ? (
                  <img
                    src={"assets/icons/social/heart.svg"}
                    style={{ width: 20, height: 19 }}
                  />
                ) : (
                  <img
                    src={"assets/icons/social/like.svg"}
                    style={{ width: 18, height: 18 }}
                  />
                )}
                <Typography
                  variant="caption"
                  sx={{
                    color:
                      liked && social_links?.likes > 0
                        ? "#459173"
                        : "rgba(74, 94, 109, 1)",
                    fontWeight: 500,
                  }}
                >
                  {social_links?.likes}
                </Typography>
              </Stack>

              <Stack
                direction={"row"}
                alignItems={"center"}
                spacing={1}
                sx={{ cursor: "pointer" }}
                onClick={copyToClipboard}
              >
                <img
                  src={"assets/icons/social/share.png"}
                  style={{ width: 18, height: 18 }}
                />
                <Typography
                  variant="caption"
                  sx={{
                    color: "rgba(74, 94, 109, 1)",
                    fontWeight: 500,
                  }}
                >
                  {isMedium ? "" : "Share"}
                </Typography>
              </Stack>
            </Box>
          )}
          <Divider />
        </Box>
      </Box>
    </Box>
  );
};

export default ReportContainer;
